import { Component, inject } from '@angular/core';

import { ThemeService } from './theme.service.js';
import type { Theme } from './theme.types.js';

interface Option {
  value: Theme;
  label: string;
  icon: string;
}

const OPTIONS: readonly Option[] = [
  { value: 'light',  label: 'Light',  icon: '☀' },
  { value: 'dark',   label: 'Dark',   icon: '☾' },
  { value: 'system', label: 'System', icon: '💻' },
];

/**
 * Tri-radio theme picker for settings pages. Exposes the full
 * light / dark / system choice — the `'system'` option is what lets users
 * opt into following the OS preference.
 */
@Component({
  selector: 'es-theme-selector',
  template: `
    <ul role="radiogroup" class="flex flex-col gap-1">
      @for (opt of options; track opt.value) {
        <li>
          <button
            type="button"
            role="radio"
            [attr.aria-checked]="opt.value === theme.theme()"
            class="w-full flex items-center gap-3 px-3 py-2 rounded-lg border cursor-pointer text-sm text-left transition-colors"
            [class]="opt.value === theme.theme()
              ? 'border-echo-blue bg-echo-blue/10 text-echo-blue'
              : 'border-[var(--border)] text-[var(--text-secondary)] hover:bg-[var(--bg-card-hover)]'"
            (click)="theme.setTheme(opt.value)"
          >
            <span aria-hidden="true" class="text-lg">{{ opt.icon }}</span>
            <span class="flex-1">{{ opt.label }}</span>
            @if (opt.value === theme.theme()) {
              <span aria-hidden="true">✓</span>
            }
          </button>
        </li>
      }
    </ul>
  `,
})
export class ThemeSelectorComponent {
  readonly theme = inject(ThemeService);
  readonly options = OPTIONS;
}
